import { createAction, props } from '@ngrx/store';

export namespace MainNavigationActions {
  export enum MainNavigationActionTypes {
    GoToProfile = '[Router] Navigate to profile page',
    GoToAdminArea = '[Router] Navigate to admin area page',
    GoToStatisticsOverview = '[Router] Navigate to statistics overview page',
    GoToUserDetails = '[Router] Navigate to user details page',
    GoToUserControllPanel = '[Router] Navigate to user controll pannel page',
    GoToLegalNotice = '[Router] Navigate to legal notice page',
    GoToPrivacyPolicy = '[Router] Navigate to privacy policy page',
    GoToJointResponsibilityAgreement = '[Router] Navigate to Joint Responsibility Agreement page',
  }
  export const goToProfile = createAction(MainNavigationActionTypes.GoToProfile);

  export const goToLegalNotice = createAction(MainNavigationActionTypes.GoToLegalNotice);

  export const goToPrivacyPolicy = createAction(MainNavigationActionTypes.GoToPrivacyPolicy);

  export const goToJointResponsibilityAgreement = createAction(MainNavigationActionTypes.GoToJointResponsibilityAgreement);

  export const goToAdminArea = createAction(MainNavigationActionTypes.GoToAdminArea);

  export const goToStatisticsOverview = createAction(MainNavigationActionTypes.GoToStatisticsOverview);

  export const goToUserDetails = createAction(
    MainNavigationActionTypes.GoToUserDetails,
    props<{ userId: string }>()
  );

  export const goToUserControllPanel = createAction(
    MainNavigationActionTypes.GoToUserControllPanel,
    props<{ userId: string }>()
  );
}
